<template>
  <div>
    <PageHeading
      default-heading="We're unable to open a trust account for you"
      edit-heading="We're unable to open a trust account for you"
    />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div class="pvd-container container-divider">
        <h2 class="pvd-heading-L">
          You may need {{ idVerificationName() }} to setup an account or update their information
        </h2>
        <p>
          Please have {{ idVerificationName() }} check to see if they have a brokerage or IRA account with us.
            Afterwards, please ensure they have their latest contact information on file.
        </p>
        <br>
        <p>If they do not have an account, they can create one <a class="pvd-link__link"
          href="https://www.fidelity.com/open-account/overview">here</a>.</p>
      </div>
      <NavigationComponent @next-action="handleWidgetSubmit" />
    </form>
  </div>
</template>
<script>
import utilityFunctions from '../mixins/utility';
import PageHeading from '../components/PageHeading.vue';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import NavigationComponent from '../components/NavigationComponent.vue';

export default {
  name: 'TrustCustomerNotFound',
  components: {
    NavigationComponent,
    PageHeading,
  },
  mixins: [
    utilityFunctions,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
    pageNavigationHelper,
  ],
  computed: {
    pageHeader() {
      const pageHeader = this.pd_content.page_header;
      if (pageHeader) {
        const heading = this.cs_editMode ? pageHeader.edit : pageHeader.default;

        if (heading) {
          document.title = this.setTitle(heading);
        }
        return heading;
      }
      return '';
    },
  },
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-customer-not-found' });
  },
  methods: {
    idVerificationName() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`;
      }
      return `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`;
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}
</style>
